// Merging customers (BL-029) as the office sees it: the preview's answer, the typed confirmation, and
// what an old link to a merged customer says when it opens the kept one.

/** customers.previewMerge: what moves, in words, and what else happens. */
export interface MergePlan {
  keep: { id: string; number: string; displayName: string };
  merge: { id: string; number: string; displayName: string };
  moves: string[];
  notes: string[];
  balanceCents: number;
}

/** The person typed the merged customer's number (any case, spaces around it ignored), as the server checks. */
export const mergeConfirmed = (typed: string, number: string) =>
  typed.trim().length > 0 && typed.trim().toUpperCase() === number.toUpperCase();

/**
 * customers.get answers a merged customer's id with the kept one (mergedFrom): the line that says so,
 * or null for a customer asked for by its own id.
 */
/**
 * A read for the open customer answered not found (QA-559): perhaps merged into another while it
 * was open. customers.get then says where it went.
 */
export const customerGone = (e: unknown): boolean =>
  typeof e === 'object' && e !== null && (e as { code?: unknown }).code === 'not_found';

/**
 * Whether a call's input names this customer (QA-565): one of its fields, or a field one level down,
 * is the customer's id, as tags.assign's entityId or customers.update's id is.
 */
export function namesCustomer(input: unknown, customerId: string): boolean {
  if (typeof input !== 'object' || input === null) return false;
  return Object.values(input).some(
    (v) =>
      v === customerId ||
      (typeof v === 'object' && v !== null && !Array.isArray(v) && Object.values(v).includes(customerId)),
  );
}

export function mergedNotice(c: { number: string; mergedFrom?: { number: string } }): string | null {
  return c.mergedFrom ? `${c.mergedFrom.number} was merged into ${c.number}. This is ${c.number}.` : null;
}
